// extracted by mini-css-extract-plugin
module.exports = {"icon":"Button_icon__vTXze","badge":"Button_badge__318Qa","status":"Button_status__1QntR"};